module.exports = __webpack_public_path__ + "img/GuckMalMeinProfil.ce7b0e60.svg";